import { createReducer, on } from '@ngrx/store';
import {
  deleteConsumedApi,
  deleteConsumedProvider,
  deleteConsumedComponent,
  getConsumedAPIByComponentId,
  saveConsumedApiBatchState,
  saveConsumedProvider,
  saveConsumedProviderState,
  saveConsumedComponent,
  saveConsumedComponentState,
  setAPIByProviderId,
  setAPIByComponentId,
  setComponentByProviderId,
  setDeleteConsumedApi,
  setDeleteConsumedProvider,
  setDeleteConsumedComponent,
  setConsumedApi,
  setConsumedApiAdvanceSearch,
  setConsumedApiAutosuggest,
  setConsumedProviderAdvanceSearch,
  setConsumedProviderAutosuggest,
  setConsumedProviderTable,
  setConsumedComponent,
  setConsumedComponentAdvanceSearch,
  setConsumedComponentAutosuggest,
  setConsumedComponentTable,
  setNewlyConsumedApis
} from '../actions/consumedrest.actions';

export interface ConsumedRestsState {
  data: any;
}

export const initialState: ConsumedRestsState = {
  data: {}
};

export const consumedrestReducer = createReducer(
  initialState,
  on(saveConsumedProviderState, (state: any, { success, consumedProvider }) => {
    return {
      ...state,
      ...{ consumedProvider },
      providerCreateState: success,
      loader: false
    };
  }),
  on(saveConsumedComponentState, (state: any, { success, consumedComponent }) => {
    return {
      ...state,
      ...{ consumedComponent },
      componentCreateState: success,
      loader: false
    };
  }),
  on(saveConsumedApiBatchState, (state: any, { success, consumedApiBatch }) => {
    return {
      ...state,
      ...{ consumedApiBatch },
      apiBatchCreateState: success,
      loader: false
    };
  }),
  on(setConsumedProviderTable, (state, { consumedProviderTable }) => ({
    ...state,
    loader: false,
    ...{ consumedProviderTable }
  })),
  on(saveConsumedComponent, (state) => ({
    ...state,
    loader: true
  })),
  on(saveConsumedProvider, (state) => ({
    ...state,
    loader: true
  })),
  on(setConsumedComponentTable, (state, { consumedComponentTable }) => ({
    ...state,
    ...{ consumedComponentTable }
  })),
  on(setConsumedComponent, (state, { consumedComponent }) => {
    return {
      ...state,
      ...{ consumedComponent }
    };
  }),
  on(setConsumedApi, (state, { consumedApi }) => ({
    ...state,
    ...{ consumedApi }
  })),
  on(setNewlyConsumedApis, (state, { newlyConsumedApiTable }) => ({
    ...state,
    ...{ newlyConsumedApiTable }
  })),
  on(saveConsumedProvider, (state, { consumedProviderData }) => ({
    ...state,
    ...consumedProviderData
  })),
  on(getConsumedAPIByComponentId, (state, { params }) => ({
    ...state,
    componentId: params.functionalcompid
  })),
  on(deleteConsumedProvider, (state, { ids }) => ({
    ...state,
    ...ids,
    ...{ deletedProvider: false }
  })),
  on(setDeleteConsumedProvider, (state, { deletedProvider }) => ({
    ...state,
    ...{ deletedProvider: deletedProvider }
  })),
  on(deleteConsumedComponent, (state, { ids }) => ({
    ...state,
    ...ids,
    ...{ deletedComponent: false }
  })),
  on(setDeleteConsumedComponent, (state, { deletedComponent }) => ({
    ...state,
    ...{ deletedComponent: deletedComponent }
  })),
  on(deleteConsumedApi, (state, { ids }) => ({
    ...state,
    ...{ ids },
    ...{ deletedApi: false }
  })),
  on(setDeleteConsumedApi, (state, { deletedApi }) => ({
    ...state,
    ...{ deletedApi: deletedApi }
  })),
  on(setComponentByProviderId, (state, { consumedComponentByProvider }) => ({
    ...state,
    ...{ consumedComponentByProvider }
  })),
  on(setAPIByComponentId, (state, { consumedAPIByComponent }) => ({
    ...state,
    ...{ consumedAPIByComponent }
  })),
  on(setAPIByProviderId, (state, { consumedAPIByProvider }) => ({
    ...state,
    ...{ consumedAPIByProvider }
  })),
  on(setConsumedComponentAutosuggest, (state, { componentAutosuggestResults }) => ({
    ...state,
    ...{ componentAutosuggestResults }
  })),
  on(setConsumedApiAutosuggest, (state, { apiAutosuggestResults }) => ({
    ...state,
    ...{ apiAutosuggestResults }
  })),
  on(setConsumedProviderAutosuggest, (state, { providerAutosuggestResults }) => ({
    ...state,
    ...{ providerAutosuggestResults }
  })),
  on(setConsumedProviderAdvanceSearch, (state, { providerAdvanceSearchtResults }) => ({
    ...state,
    ...{ providerAdvanceSearchtResults }
  })),
  on(setConsumedComponentAdvanceSearch, (state, { componentAdvanceSearchRsults }) => ({
    ...state,
    ...{ componentAdvanceSearchRsults }
  })),
  on(setConsumedApiAdvanceSearch, (state, { apiAdvanceSearchResults }) => ({
    ...state,
    ...{ apiAdvanceSearchResults }
  }))
);
